import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { SplashScreen } from "./components/SplashScreen";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { Catalog } from "./pages/Catalog";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Privacy } from "./pages/Privacy";
import { Cookies } from "./pages/Cookies";
import { KVKK } from "./pages/KVKK";
import { ConveyorDetail } from "./pages/ConveyorDetail";
import { ChocolateDetail } from "./pages/ChocolateDetail";
import { CNCDetail } from "./pages/CNCDetail";
import { HelicalDetail } from "./pages/HelicalDetail";
import { CustomDetail } from "./pages/CustomDetail";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [showSplash, setShowSplash] = useState(false);
  const [splashCompleted, setSplashCompleted] = useState(false);

  useEffect(() => {
    const splashShown = sessionStorage.getItem('splash_shown');
    if (!splashShown) {
      setShowSplash(true);
    } else {
      setSplashCompleted(true);
    }
  }, []);

  const handleSplashComplete = () => {
    sessionStorage.setItem('splash_shown', 'true');
    setShowSplash(false);
    setSplashCompleted(true);
  };

  return (
    <LanguageProvider>
      <BrowserRouter>
        {showSplash && <SplashScreen onComplete={handleSplashComplete} />}

        {splashCompleted && (
          <>
            <ScrollToTop />
            <div className="App">
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/conveyor" element={<ConveyorDetail />} />
                <Route path="/services/chocolate" element={<ChocolateDetail />} />
                <Route path="/services/cnc" element={<CNCDetail />} />
                <Route path="/services/helical" element={<HelicalDetail />} />
                <Route path="/services/custom" element={<CustomDetail />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="/kvkk" element={<KVKK />} />
              </Routes>
              <Footer />
              <Toaster />
            </div>
          </>
        )}
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
